import apiClient from '../lib/apiClient';

const clientSiteService = {
  // Get all client sites
  getClientSites: async (filters = {}) => {
    try {
      const result = await apiClient.get('/client-sites', filters);
      return result;
    } catch (error) {
      return { 
        success: false, 
        error: error.message || 'Failed to fetch client sites' 
      };
    }
  },

  // Get client site by ID
  getClientSite: async (siteId) => {
    try {
      const result = await apiClient.get(`/client-sites/${siteId}`);
      return result;
    } catch (error) {
      return { 
        success: false, 
        error: error.message || 'Failed to fetch client site details' 
      };
    }
  },

  // Create new client site
  createClientSite: async (siteData) => {
    try {
      const result = await apiClient.post('/client-sites', siteData);
      return result;
    } catch (error) {
      return { 
        success: false, 
        error: error.message || 'Failed to create client site' 
      };
    }
  },

  // Update client site
  updateClientSite: async (siteId, siteData) => {
    try {
      const result = await apiClient.put(`/client-sites/${siteId}`, siteData);
      return result;
    } catch (error) {
      return { 
        success: false, 
        error: error.message || 'Failed to update client site' 
      };
    }
  },

  // Delete client site
  deleteClientSite: async (siteId) => {
    try {
      const result = await apiClient.delete(`/client-sites/${siteId}`);
      return result;
    } catch (error) {
      return { 
        success: false, 
        error: error.message || 'Failed to delete client site' 
      };
    }
  }
};

export default clientSiteService;

